import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch, useSelector } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

import { StringModifier, modifyString } from 'constants/copyHelpers';

import { Divider } from 'uiToolkitV1/Divider';

import { RealignPanelHeader } from '../../Components/SectionHeaders';
import { SECONDARY_PANEL_TYPES } from '../../krDrawerSecondaryPanelSlice';
import { RealignSection } from './RealignSection';

export const RealignPanel = () => {
  const dispatch = useDispatch();
  const [isCollapse, setIsCollapse] = React.useState(false);
  const onCollapse = () => {
    setIsCollapse(!isCollapse);
  };

  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const { type, details } = useSelector(kRDrawerSecondaryPanelSelector);

  const isChildrenRealignPanel = type === SECONDARY_PANEL_TYPES.REALIGN_CHILDREN;
  const isDeletionChildrenRealignPanel = type === SECONDARY_PANEL_TYPES.REALIGN_CHILDREN_AND_DELETE;

  const headerText =
    isChildrenRealignPanel || isDeletionChildrenRealignPanel
      ? `Re-align Child ${modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE)} for`
      : `Re-align Parent ${moduleName} for`;

  return (
    <Flex backgroundColor="#FFFFFF" h="100%" flexDirection="column">
      <RealignPanelHeader headerText={headerText} onCollapse={onCollapse} {...details} />
      <Divider sx={{ borderColor: '#CFD7DF' }} />
      <RealignSection key={type} isCollapse={isCollapse} />
    </Flex>
  );
};
